"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSAFE_Arrowhead = exports.UNSAFE_Arrow = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _core = require("../core");
var _eero = require("../theme/eero");
var _excluded = ["rotationDirection", "lineColor", "thickness", "size"],
  _excluded2 = ["rotationDirection", "lineColor", "thickness", "size", "unboundedLength"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_2k6xwkbgox() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Arrow.tsx";
  var hash = "9ee945d8afdf29b1889cf533dac17c21e00e33cd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Arrow.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 54
        },
        end: {
          line: 11,
          column: 61
        }
      },
      "1": {
        start: {
          line: 12,
          column: 26
        },
        end: {
          line: 12,
          column: 27
        }
      },
      "2": {
        start: {
          line: 13,
          column: 27
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "3": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 14,
          column: 53
        }
      },
      "4": {
        start: {
          line: 16,
          column: 56
        },
        end: {
          line: 16,
          column: 73
        }
      },
      "5": {
        start: {
          line: 17,
          column: 26
        },
        end: {
          line: 17,
          column: 52
        }
      },
      "6": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 54
        }
      },
      "7": {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "8": {
        start: {
          line: 29,
          column: 33
        },
        end: {
          line: 29,
          column: 47
        }
      },
      "9": {
        start: {
          line: 30,
          column: 41
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "10": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 38,
          column: 23
        }
      },
      "11": {
        start: {
          line: 34,
          column: 3
        },
        end: {
          line: 38,
          column: 22
        }
      },
      "12": {
        start: {
          line: 40,
          column: 22
        },
        end: {
          line: 45,
          column: 26
        }
      },
      "13": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 45,
          column: 26
        }
      },
      "14": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 52,
          column: 22
        }
      },
      "15": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 52,
          column: 22
        }
      },
      "16": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "17": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 60,
          column: 25
        }
      },
      "18": {
        start: {
          line: 56,
          column: 5
        },
        end: {
          line: 60,
          column: 24
        }
      },
      "19": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 63,
          column: 4
        }
      },
      "20": {
        start: {
          line: 67,
          column: 66
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "21": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 82,
          column: 8
        }
      },
      "22": {
        start: {
          line: 86,
          column: 51
        },
        end: {
          line: 139,
          column: 1
        }
      },
      "23": {
        start: {
          line: 94,
          column: 23
        },
        end: {
          line: 94,
          column: 72
        }
      },
      "24": {
        start: {
          line: 95,
          column: 42
        },
        end: {
          line: 95,
          column: 84
        }
      },
      "25": {
        start: {
          line: 97,
          column: 47
        },
        end: {
          line: 107,
          column: 3
        }
      },
      "26": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 106,
          column: 11
        }
      },
      "27": {
        start: {
          line: 109,
          column: 33
        },
        end: {
          line: 117,
          column: 3
        }
      },
      "28": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "29": {
        start: {
          line: 119,
          column: 20
        },
        end: {
          line: 126,
          column: 3
        }
      },
      "30": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 125,
          column: 6
        }
      },
      "31": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 138,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 22
          },
          end: {
            line: 29,
            column: 23
          }
        },
        loc: {
          start: {
            line: 29,
            column: 33
          },
          end: {
            line: 29,
            column: 47
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 31
          }
        },
        loc: {
          start: {
            line: 30,
            column: 41
          },
          end: {
            line: 30,
            column: 55
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 21
          }
        },
        loc: {
          start: {
            line: 34,
            column: 3
          },
          end: {
            line: 38,
            column: 22
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 22
          },
          end: {
            line: 40,
            column: 23
          }
        },
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 45,
            column: 26
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 22
          }
        },
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 52,
            column: 22
          }
        },
        line: 48
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 19
          }
        },
        loc: {
          start: {
            line: 54,
            column: 52
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 54
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 22
          }
        },
        loc: {
          start: {
            line: 56,
            column: 5
          },
          end: {
            line: 60,
            column: 24
          }
        },
        line: 56
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 67,
            column: 66
          },
          end: {
            line: 67,
            column: 67
          }
        },
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 82,
            column: 8
          }
        },
        line: 74
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 86,
            column: 51
          },
          end: {
            line: 86,
            column: 52
          }
        },
        loc: {
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 139,
            column: 1
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 97,
            column: 47
          },
          end: {
            line: 97,
            column: 48
          }
        },
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 106,
            column: 11
          }
        },
        line: 98
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 109,
            column: 33
          },
          end: {
            line: 109,
            column: 34
          }
        },
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 116,
            column: 6
          }
        },
        line: 110
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 119,
            column: 20
          },
          end: {
            line: 119,
            column: 21
          }
        },
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 125,
            column: 6
          }
        },
        line: 120
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 3
          },
          end: {
            line: 38,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 3
          },
          end: {
            line: 38,
            column: 14
          }
        }, {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 38,
            column: 22
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 72
          },
          end: {
            line: 40,
            column: 95
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 40,
            column: 90
          },
          end: {
            line: 40,
            column: 95
          }
        }],
        line: 40
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 45,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 42,
            column: 22
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 26
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 12
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 26
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 71
          },
          end: {
            line: 47,
            column: 94
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 47,
            column: 89
          },
          end: {
            line: 47,
            column: 94
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 52,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 51,
            column: 28
          }
        }, {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 22
          }
        }],
        line: 48
      },
      "6": {
        loc: {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 51,
            column: 28
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 14
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 28
          }
        }],
        line: 49
      },
      "7": {
        loc: {
          start: {
            line: 56,
            column: 5
          },
          end: {
            line: 60,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 5
          },
          end: {
            line: 60,
            column: 16
          }
        }, {
          start: {
            line: 60,
            column: 20
          },
          end: {
            line: 60,
            column: 24
          }
        }],
        line: 56
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 20
          },
          end: {
            line: 62,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 64
          },
          end: {
            line: 62,
            column: 81
          }
        }, {
          start: {
            line: 62,
            column: 84
          },
          end: {
            line: 62,
            column: 99
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 22
          },
          end: {
            line: 68,
            column: 48
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 69,
            column: 23
          }
        }],
        line: 69
      },
      "11": {
        loc: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 70,
            column: 14
          },
          end: {
            line: 70,
            column: 31
          }
        }],
        line: 70
      },
      "12": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 27
          }
        }],
        line: 71
      },
      "13": {
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 87,
            column: 22
          },
          end: {
            line: 87,
            column: 48
          }
        }],
        line: 87
      },
      "14": {
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 23
          }
        }],
        line: 88
      },
      "15": {
        loc: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 14
          },
          end: {
            line: 89,
            column: 31
          }
        }],
        line: 89
      },
      "16": {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 90,
            column: 16
          },
          end: {
            line: 90,
            column: 34
          }
        }],
        line: 90
      },
      "17": {
        loc: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 91,
            column: 20
          },
          end: {
            line: 91,
            column: 25
          }
        }],
        line: 91
      },
      "18": {
        loc: {
          start: {
            line: 103,
            column: 21
          },
          end: {
            line: 103,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 103,
            column: 36
          },
          end: {
            line: 103,
            column: 41
          }
        }, {
          start: {
            line: 103,
            column: 44
          },
          end: {
            line: 103,
            column: 52
          }
        }],
        line: 103
      },
      "19": {
        loc: {
          start: {
            line: 128,
            column: 9
          },
          end: {
            line: 138,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 132,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 137,
            column: 14
          }
        }],
        line: 128
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0],
      "11": [0],
      "12": [0],
      "13": [0],
      "14": [0],
      "15": [0],
      "16": [0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9ee945d8afdf29b1889cf533dac17c21e00e33cd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2k6xwkbgox = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2k6xwkbgox();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_ROTATION_DIRECTION = (cov_2k6xwkbgox().s[0]++, 'right');
var DEFAULT_THICKNESS = (cov_2k6xwkbgox().s[1]++, 2);
var DEFAULT_ARROW_SIZE = (cov_2k6xwkbgox().s[2]++, 10);
var DEFAULT_ARROW_LENGTH = (cov_2k6xwkbgox().s[3]++, ['35px', '35px', '60px']);
var HORIZONTAL_DIRECTIONS = (cov_2k6xwkbgox().s[4]++, ['left', 'right']);
var HORIZONTAL_MARGIN = (cov_2k6xwkbgox().s[5]++, "-".concat(DEFAULT_ARROW_SIZE, "px"));
var VERTICAL_MARGIN = (cov_2k6xwkbgox().s[6]++, "-".concat(DEFAULT_ARROW_SIZE * 2, "px"));
var RotatedArrowhead = (cov_2k6xwkbgox().s[7]++, /*#__PURE__*/(0, _base["default"])(_core.Box, process.env.NODE_ENV === "production" ? {
  target: "evx4x310"
} : {
  target: "evx4x310",
  label: "RotatedArrowhead"
})("transform:rotate(", function (props) {
  cov_2k6xwkbgox().f[0]++;
  cov_2k6xwkbgox().s[8]++;
  return props.rotation;
}, "deg);-webkit-transform:rotate(", function (props) {
  cov_2k6xwkbgox().f[1]++;
  cov_2k6xwkbgox().s[9]++;
  return props.rotation;
}, "deg);" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
cov_2k6xwkbgox().s[10]++;
var rotateArrow = function rotateArrow(direction) {
  cov_2k6xwkbgox().f[2]++;
  cov_2k6xwkbgox().s[11]++;
  return (cov_2k6xwkbgox().b[0][0]++, {
    right: -45,
    left: 135,
    down: 45
  }[direction]) || (cov_2k6xwkbgox().b[0][1]++, -135);
};
cov_2k6xwkbgox().s[12]++;
var getBodyHeight = function getBodyHeight(direction, thickness) {
  var unboundedLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2k6xwkbgox().b[1][0]++, false);
  cov_2k6xwkbgox().f[3]++;
  cov_2k6xwkbgox().s[13]++;
  return HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[2][0]++, "".concat(thickness, "px")) : (cov_2k6xwkbgox().b[2][1]++, unboundedLength ? (cov_2k6xwkbgox().b[3][0]++, '100%') : (cov_2k6xwkbgox().b[3][1]++, DEFAULT_ARROW_LENGTH));
};
cov_2k6xwkbgox().s[14]++;
var getBodyWidth = function getBodyWidth(direction, thickness) {
  var unboundedLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2k6xwkbgox().b[4][0]++, false);
  cov_2k6xwkbgox().f[4]++;
  cov_2k6xwkbgox().s[15]++;
  return HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[5][0]++, unboundedLength ? (cov_2k6xwkbgox().b[6][0]++, '100%') : (cov_2k6xwkbgox().b[6][1]++, DEFAULT_ARROW_LENGTH)) : (cov_2k6xwkbgox().b[5][1]++, "".concat(thickness, "px"));
};
cov_2k6xwkbgox().s[16]++;
var getMargin = function getMargin(direction) {
  cov_2k6xwkbgox().f[5]++;
  cov_2k6xwkbgox().s[17]++;
  var marginType = function marginType() {
    cov_2k6xwkbgox().f[6]++;
    cov_2k6xwkbgox().s[18]++;
    return (cov_2k6xwkbgox().b[7][0]++, {
      right: 'ml',
      left: 'mr',
      down: 'mt'
    }[direction]) || (cov_2k6xwkbgox().b[7][1]++, 'mb');
  };
  cov_2k6xwkbgox().s[19]++;
  return _defineProperty({}, marginType(), HORIZONTAL_DIRECTIONS.includes(direction) ? (cov_2k6xwkbgox().b[8][0]++, HORIZONTAL_MARGIN) : (cov_2k6xwkbgox().b[8][1]++, VERTICAL_MARGIN));
};

/** @deprecated Use the Arrowhead from Spritesheet */
cov_2k6xwkbgox().s[20]++;
var UNSAFE_Arrowhead = exports.UNSAFE_Arrowhead = function UNSAFE_Arrowhead(_ref2) {
  var _ref2$rotationDirecti = _ref2.rotationDirection,
    rotationDirection = _ref2$rotationDirecti === void 0 ? (cov_2k6xwkbgox().b[9][0]++, DEFAULT_ROTATION_DIRECTION) : _ref2$rotationDirecti,
    _ref2$lineColor = _ref2.lineColor,
    lineColor = _ref2$lineColor === void 0 ? (cov_2k6xwkbgox().b[10][0]++, 'brand50') : _ref2$lineColor,
    _ref2$thickness = _ref2.thickness,
    thickness = _ref2$thickness === void 0 ? (cov_2k6xwkbgox().b[11][0]++, DEFAULT_THICKNESS) : _ref2$thickness,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? (cov_2k6xwkbgox().b[12][0]++, DEFAULT_ARROW_SIZE) : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  cov_2k6xwkbgox().f[7]++;
  cov_2k6xwkbgox().s[21]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, rest, /*#__PURE__*/_react["default"].createElement(RotatedArrowhead, {
    border: "solid ".concat(_eero.colors[lineColor]),
    borderWidth: "0 ".concat(thickness, "px ").concat(thickness, "px 0"),
    display: "inline-block",
    padding: "".concat(size, "px"),
    rotation: rotateArrow(rotationDirection)
  }));
};

/** @deprecated */
cov_2k6xwkbgox().s[22]++;
var UNSAFE_Arrow = exports.UNSAFE_Arrow = function UNSAFE_Arrow(_ref3) {
  var _ref3$rotationDirecti = _ref3.rotationDirection,
    rotationDirection = _ref3$rotationDirecti === void 0 ? (cov_2k6xwkbgox().b[13][0]++, DEFAULT_ROTATION_DIRECTION) : _ref3$rotationDirecti,
    _ref3$lineColor = _ref3.lineColor,
    lineColor = _ref3$lineColor === void 0 ? (cov_2k6xwkbgox().b[14][0]++, 'brand50') : _ref3$lineColor,
    _ref3$thickness = _ref3.thickness,
    thickness = _ref3$thickness === void 0 ? (cov_2k6xwkbgox().b[15][0]++, DEFAULT_THICKNESS) : _ref3$thickness,
    _ref3$size = _ref3.size,
    _size = _ref3$size === void 0 ? (cov_2k6xwkbgox().b[16][0]++, DEFAULT_ARROW_SIZE) : _ref3$size,
    _ref3$unboundedLength = _ref3.unboundedLength,
    unboundedLength = _ref3$unboundedLength === void 0 ? (cov_2k6xwkbgox().b[17][0]++, false) : _ref3$unboundedLength,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  cov_2k6xwkbgox().f[8]++;
  var isHorizontal = (cov_2k6xwkbgox().s[23]++, HORIZONTAL_DIRECTIONS.includes(rotationDirection));
  var shouldArrowheadAppearBeforeBody = (cov_2k6xwkbgox().s[24]++, ['left', 'up'].includes(rotationDirection));
  cov_2k6xwkbgox().s[25]++;
  var Wrapper = function Wrapper(_ref4) {
    var children = _ref4.children;
    cov_2k6xwkbgox().f[9]++;
    cov_2k6xwkbgox().s[26]++;
    return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
      alignItems: "center",
      height: "100%",
      justifyContent: "center",
      mx: "10px",
      flexDirection: isHorizontal ? (cov_2k6xwkbgox().b[18][0]++, 'row') : (cov_2k6xwkbgox().b[18][1]++, 'column')
    }, children);
  };
  cov_2k6xwkbgox().s[27]++;
  var ParameterizedArrowhead = function ParameterizedArrowhead() {
    cov_2k6xwkbgox().f[10]++;
    cov_2k6xwkbgox().s[28]++;
    return /*#__PURE__*/_react["default"].createElement(UNSAFE_Arrowhead, _extends({}, getMargin(rotationDirection), {
      rotationDirection: rotationDirection,
      size: thickness * 2,
      lineColor: lineColor
    }, rest));
  };
  cov_2k6xwkbgox().s[29]++;
  var ArrowBody = function ArrowBody() {
    cov_2k6xwkbgox().f[11]++;
    cov_2k6xwkbgox().s[30]++;
    return /*#__PURE__*/_react["default"].createElement(_core.Box, {
      height: getBodyHeight(rotationDirection, thickness, unboundedLength),
      width: getBodyWidth(rotationDirection, thickness, unboundedLength),
      background: lineColor,
      mt: "-".concat(thickness * 2, "px")
    });
  };
  cov_2k6xwkbgox().s[31]++;
  return shouldArrowheadAppearBeforeBody ? (cov_2k6xwkbgox().b[19][0]++, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(ParameterizedArrowhead, null), /*#__PURE__*/_react["default"].createElement(ArrowBody, null))) : (cov_2k6xwkbgox().b[19][1]++, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(ArrowBody, null), /*#__PURE__*/_react["default"].createElement(ParameterizedArrowhead, null)));
};